/**
 * Lightweight footer newsletter spam guard (honeypot + min time-to-submit).
 * No double opt-in. Silent fake success when checks fail.
 */
(function () {
  var MIN_MS = 3000;
  var pageLoadedAt = Date.now();

  function fakeSuccess(form) {
    var email = form.querySelector('#ContactFooter-email, input[name="contact[email]"]');
    var field = form.querySelector('.field');
    var err = form.querySelector('#ContactFooter-error');
    if (err) err.remove();
    if (field) field.style.display = 'none';
    if (email) {
      email.removeAttribute('required');
      email.value = '';
    }
    var existing = form.querySelector('#ContactFooter-success');
    if (existing) {
      existing.focus();
      return;
    }
    var p = document.createElement('p');
    p.className = 'form__message h3';
    p.id = 'ContactFooter-success';
    p.setAttribute('tabindex', '-1');
    p.textContent = 'Thanks for subscribing';
    form.appendChild(p);
    try {
      p.focus();
    } catch (e) {}
  }

  function isSpam(form) {
    var hp = form.querySelector('[name="mse_hp"], .mse-newsletter-hp');
    if (hp && String(hp.value || '').trim() !== '') return true;
    if (Date.now() - pageLoadedAt < MIN_MS) return true;
    return false;
  }

  function bind(form) {
    if (!form || form.dataset.mseNlGuard === '1') return;
    form.dataset.mseNlGuard = '1';
    form.addEventListener(
      'submit',
      function (e) {
        if (!isSpam(form)) return;
        e.preventDefault();
        e.stopImmediatePropagation();
        fakeSuccess(form);
      },
      true
    );
  }

  function init() {
    bind(document.getElementById('ContactFooter'));
    document.querySelectorAll('form.footer__newsletter, form.newsletter-form#ContactFooter').forEach(bind);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
